<!--
 * @Description: 
 * @Author: DOJO
 * @Date: 2020-04-01 23:57:59
 * @LastEditTime: 2020-04-02 17:43:26
 * @LastEditors: DOJO
 -->
<template>
  <transition name="fade">
    <div class="video-model" v-show="video.visible">
      <div class="video-mask" @click.stop.prevent="closeModel">
      </div>
      <div class="video-box">
        <video id="mVideo" 
          class="video" 
          :src="video.src" 
          width="100%"
    　　　 height="100%"
          controls
          style="object-fit:fill"
          webkit-playsinline="true" 
          x-webkit-airplay="true"
          playsinline="true"
          x5-video-player-type="h5" 
          x5-video-orientation="h5"
          x5-video-player-fullscreen="true"
          preload="auto" 
          autoplay="autoplay">
        </video>
      </div>
    </div>
  </transition>
</template>
<script>
/* ======= 视频展示组件 ======= */
// import Vue from 'vue';
// import YunJi from 'common/js/YunJi.js';
export default {
  name: 'videoModel',
  props: {
    video: {
      type: Object,
      default() {
        return {
          src: '',
          visible: false
        }
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      // const oVideo = document.getElementById('mVideo')
      // if (oVideo) {
      //   oVideo.oncanplaythrough = (ele) => {
      //     console.log(Math.floor(ele.target.duration * 1000))
      //   }
      //   oVideo.addEventListener('loadedmetadata', (e) => {
      //     console.log(e)
      //   })
      // }
    })
  },
  methods: {
    closeModel() {
      this.video.visible = false
      document.getElementById('mVideo').pause()
    },
    playVideo() {
      this.$nextTick(() => {
        document.getElementById('mVideo').play()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .video-model{

    .video-mask{ 
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.9);
      position: fixed;
      z-index: 998;
      left: 0;
      top: 0;
    }
    .video-box{
      position: fixed;
      left: 0;
      top: 50%;
      width: 100%;
      height: 8rem;
      z-index: 999;
      transform: translateY(-50%);
      .video{
        width: 90%;
        margin: 0 auto;
        height: 100%;
        display: block;
      }
    }
  }

  .fade-enter, .fade-leave-to { opacity: 0; }
  .fade-leave, .fade-enter-to { opacity: 1; }
  .fade-enter-active, .fade-leave-active { transition: all .3s; }

</style>
